import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import io from 'socket.io-client';

export const ROLE = {
    ADMIN: process.env.REACT_APP_ADMIN_ROLE, 
    CLIENT: process.env.REACT_APP_CLIENT_ROLE, 
    MASTER: process.env.REACT_APP_MASTER_ROLE
};

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        lang: 'en',
        defaultLanguage: { value: 'en', label: 'English' },
        isAuth: false,
        user: null,
        token: null,
        socket: null,
        role: null,
        persist: localStorage.getItem('persist') === 'true',
        isMaster: false,
        isAdmin: undefined,
        unreadNotifications: [],
        unreadMessages: [],
    },
    reducers: {
        setAuth: (state, { payload }) => {
            state.token = payload.accessToken;            
            const decoded = jwtDecode(state.token);
            console.log(decoded);
            
            state.isAuth = true;
            state.user = decoded?.userInfo?.user || undefined;
            state.role = decoded?.userInfo?.role || undefined;

            state.socket = io(process.env.REACT_APP_BACKEND);
            console.log('socket:', state.socket);

            state.socket.emit('sendUser', state.user.id);

            state.socket.on('getUsers', users => {
                console.log('from server get users');
                console.log(users);
            });
        },
        logOut: (state) => {
            state.user = null;
            state.token = null;
            state.isAuth = false;
            
            state.socket.emit('logOut');
            state.socket = null;
            localStorage.removeItem('persist');

        },
        setPersist: (state, { payload }) => {
            state.persist = payload;
        },
        setLanguage: (state, { payload }) => {
            state.lang = payload;
            document.documentElement.lang = state.lang;
        },
        setDefaultLanguage: (state, { payload }) => {
            state.defaultLanguage = payload;
        },
        setNewAvatar: (state, { payload }) => {
            state.user.avatar = payload;
        },
        setProfileName: (state, { payload }) => {
            state.user.firstName = payload.firstName;
            state.user.lastName = payload.lastName;
            if (payload.phone) state.user.phone = payload.phone;
        },
        setNewLocation: (state, { payload }) => {
            state.user.masterInfo.location = payload;
        },
        addNewMessage: (state, { payload }) => {
            if (!payload?.id || !state.unreadMessages.some(message => Number(message.id) === Number(payload.id))) {
                state.unreadMessages.unshift(payload);
            }
        },
        setUnreadMessages: (state, { payload }) => {
            state.unreadMessages = payload || [];
        },
        addNotification: (state, { payload }) => {
            if (!state.unreadNotifications.some(notification => Number(notification.id) === Number(payload.id))) {
                state.unreadNotifications.unshift(payload);
            }
        },
        setUnreadNotifications: (state, { payload }) => {
            state.unreadNotifications = payload || [];
        },
        removeNotification: (state, { payload }) => {
            state.unreadNotifications = state.unreadNotifications.filter(notification => Number(notification.id) !== Number(payload));
        },
        clearNotifications: (state) => {
            state.unreadNotifications = [];
        },
        clearUnreadMessages: (state) => {
            state.unreadMessages = [];
        },
        clearUnreadMessagesByUser: (state, { payload }) => {
            const targetUser = Number(payload.targetUser);
            state.unreadMessages = state.unreadMessages.filter(message =>
                Number(message.senderFK || message.id) !== targetUser
            );
        },
    }
});

export const { setAuth, logOut, setPersist, setLanguage, setDefaultLanguage, setNewAvatar, setProfileName, setNewLocation,
    addNewMessage, setUnreadMessages, addNotification, setUnreadNotifications, removeNotification, clearNotifications,
    clearUnreadMessages,
    clearUnreadMessagesByUser
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectUnreadNotifications = (state) => state.auth.unreadNotifications;
export const selectUnreadMessages = (state) => state.auth.unreadMessages;
export const selectCurrentRole = (state) => state.auth.role;
export const selectCurrentToken = (state) => state.auth.token;
export const selectCurrentSocket = (state) => state.auth.socket;
export const selectCurrentLocation = (state) => state.auth.user?.masterInfo?.location;
export const selectPersist = (state) => state.auth.persist;

export const selectIsAuth = (state) => state.auth.isAuth;
export const selectIsAdmin = (state) => state.auth.role === ROLE.ADMIN;
export const selectIsMaster = (state) => state.auth.role === ROLE.MASTER;

export const selectDefaultLanguage = (state) => state.auth.defaultLanguage;
export const selectCurrentLanguage = (state) => state.auth.lang;
